module.exports = __webpack_public_path__ + "img/vegetable-celery-350x184.cdd7f887.jpg";